export const SSO_LOGIN_OPTIONS = {
  MICROSOFT_SSO: 'MICROSOFT_SSO',
  AUGMENTT_PASSWORD: 'AUGMENTT_PASSWORD',
}
